export default __webpack_public_path__ + "static/img-dappchaser-c65bd1f4651366aa20ad85edf67d7422.png";